/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Button,
  FormControlLabel,
  Switch,
  FormLabel,
} from "@material-ui/core";

import { useVisionLogin } from "hooks/useVisionLogin";
import { useWebsocketFetch } from "hooks/useWebsocketFetch";
import HeaderClientes from "components/_refactor/headers/clients.js";
import componentStyles from "assets/theme/views/admin/dashboard";
import componentStylesCardDeck from "assets/theme/components/cards/card-deck";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import ClearButton from "components/_refactor/button/clear";
import LoadingData from "components/Loading/LoadingData";
import TabelaMonitorInfracommerce from "./table/TableMonitorInfracommerce";
import { API_ENV } from "constants/environment";
import FromToDateField from "components/_refactor/fields/from-to-date";
import InputText from "components/_refactor/text/input";
import { IsMobile, IsMobile900 } from "utils/is-mobile";

const useStyles = makeStyles(componentStyles);
const useStylesCardDeck = makeStyles(componentStylesCardDeck);

const handleClearFinalDate = () => {
  document.getElementById("#buttonClearFinalDate").click();
};

const handleClearInitialDate = () => {
  document.getElementById("#buttonClearInitialDate").click();
};

export function DashboardMonitorInfracommerce() {
  const { userId } = useVisionLogin();
  const snackbar = useSnackbar();
  const classes = { ...useStyles(), ...useStylesCardDeck() };

  const { data, handleFetchData, status, handleFetchUrl } = useWebsocketFetch({
    onSuccess: handleGetTableData,
  });

  const [searching, setSearching] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [statusIHub, setStatusIHub] = useState(null);
  const [statusMillenium, setStatusMillenium] = useState(null);
  const [idPedido, setIdPedido] = useState("");
  const [logErro, setLogErro] = useState(true);

  const [dataLimite, setDataLimite] = useState("");
  const [dataInicial, setDataInicial] = useState("");
  const [dataFinal, setDataFinal] = useState("");

  const [errorMessage, setErrorMessage] = useState(null);
  const [dataTable, setDataTable] = useState(null);
  const [clearFilters, setClearFilters] = useState(false);
  const [lastSearchParams, setLastSearchParams] = useState(null);

  const isMobile900 = IsMobile900();
  const isMobile = IsMobile();

  const handleActiveChange = useCallback((event) => {
    setLogErro(event.target.checked);
  }, []);

  useEffect(() => {
    if (dataInicial !== "") {
      const selectedInitialDate = new Date(dataInicial);
      const data31dias = new Date(
        selectedInitialDate?.setDate(selectedInitialDate?.getDate() + 30),
      )
        .toISOString()
        .slice(0, 10);

      setDataLimite(data31dias);
    }
  }, [dataInicial]);

  const savingData = (tableData) => {
    if (tableData?.length !== 0) {
      if (
        data?.length === 1 &&
        data[0].MessageResponse === "Nenhum registro localizado"
      ) {
        setDataTable([]);
      } else {
        setDataTable(data);
      }
    } else {
      setDataTable([]);
    }
  };

  function handleGetTableData() {
    setSearching(false);
    savingData(dataTable);
  }

  const handleSearch = async () => {
    setDataTable(null);
    setLastSearchParams(null);
    setSearching(true);
    setCancelLoading(false);
    setErrorMessage(null);
    let initial;
    let final;

    if (dataInicial === "") {
      const today = new Date().toISOString().slice(0, 10);
      const selectedInitialDate = new Date(today);
      const data31dias = new Date(
        selectedInitialDate?.setDate(selectedInitialDate?.getDate() + 30),
      )
        .toISOString()
        .slice(0, 10);

      initial = today;
      final = data31dias;
    } else {
      initial = dataInicial;
      final = dataFinal;
    }

    setLastSearchParams({
      dtIni: initial,
      dtFim: final,
      statusIfc: statusIHub ? statusIHub?.name : "",
      statusMln: statusMillenium ? statusMillenium?.name : "",
      logErro: logErro?.toString(),
      idPedido: idPedido ? idPedido : "",
    });
  };

  const handleSendMessage = (message) => {
    handleFetchData(message);
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setStatusIHub(null);
    setStatusMillenium(null);
    setIdPedido("");
    setLogErro(true);

    handleClearInitialDate();
    handleClearFinalDate();
    setDataLimite("");
    setDataInicial("");
    setDataFinal("");

    setTimeout(() => {
      setClearFilters(false);
    }, 1000);
  };

  const handleStopSearching = () => {
    handleFetchUrl("");
    setCancelLoading(true);
    setSearching(false);
    setDataTable(null);
    handleFetchUrl(
      `wss://bm6fkt7kwa.execute-api.us-east-1.amazonaws.com/${API_ENV}`,
    );
  };

  useEffect(() => {
    if (
      status === "empty" &&
      !cancelLoading &&
      !searching &&
      dataTable?.length === 0
    ) {
      snackbar.showMessage("Sua busca não retornou nenhum resultado.", {
        severity: "success",
      });
    } else if (
      status === "empty" &&
      !cancelLoading &&
      searching &&
      dataTable === null
    ) {
      setSearching(false);
      snackbar.showMessage("Sua busca não retornou nenhum resultado.", {
        severity: "success",
      });
    }
  }, [status, cancelLoading, searching, dataTable]);

  useEffect(() => {
    if (lastSearchParams && userId) {
      handleSendMessage({
        action: "integration-monitor-ws",
        params: {
          querystring: lastSearchParams,
          header: {
            "K-IdUser": userId,
          },
        },
      });
    }
  }, [lastSearchParams, userId]);

  useEffect(() => {
    if (cancelLoading && dataTable === null && lastSearchParams === null) {
      handleFetchUrl(
        `wss://bm6fkt7kwa.execute-api.us-east-1.amazonaws.com/${API_ENV}`,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cancelLoading, dataTable, lastSearchParams]);

  useEffect(() => {
    if (errorMessage && !cancelLoading) {
      snackbar.showMessage(errorMessage, { severity: "error" });
    }
  }, [cancelLoading, errorMessage]);

  useEffect(() => {
    handleFetchUrl(
      `wss://bm6fkt7kwa.execute-api.us-east-1.amazonaws.com/${API_ENV}`,
    );
  }, []);

  return (
    <>
      <HeaderClientes section="Monitor Infracommerce" subsection="Dashboard" />
      <Container style={{ marginTop: "-4.5rem" }} maxWidth={false}>
        <Grid container>
          <Grid item xs={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title="Filtros"
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={6} md={4}>
                    <InputText
                      label="Número do Pedido"
                      value={idPedido}
                      onChange={(e) => {
                        setIdPedido(e.target.value.slice(0, 20));
                      }}
                      disabled={searching || clearFilters}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FromToDateField
                      label={"Período"}
                      initialDate={dataInicial}
                      finalDate={dataFinal}
                      setInitialDate={setDataInicial}
                      setFinalDate={setDataFinal}
                      disabled={searching || clearFilters}
                      isMobile={isMobile900}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <FormControlLabel
                      style={{ marginLeft: ".25rem" }}
                      control={
                        <Switch
                          checked={logErro}
                          onChange={handleActiveChange}
                          size="small"
                        />
                      }
                      disabled={searching || clearFilters}
                      label={
                        <FormLabel style={{ fontSize: "1rem" }}>
                          Log Erro
                        </FormLabel>
                      }
                      labelPlacement="end"
                      value="end"
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Button
                      color="default"
                      variant="contained"
                      style={
                        isMobile || isMobile900
                          ? {
                              width: "100%",
                              marginBottom: "0.75rem",
                              marginTop: "0.75rem",
                            }
                          : { marginBottom: "0rem" }
                      }
                      onClick={handleSearch}
                      disabled={searching || clearFilters}
                    >
                      {searching ? "Pesquisando..." : "Pesquisar"}
                    </Button>
                  </Grid>
                  <Grid
                    item
                    xs={isMobile ? 12 : isMobile900 && 6}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <ClearButton
                      disable={searching}
                      onClick={() => handleClearFilters()}
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <LoadingData
              searching={searching}
              onClick={() => handleStopSearching()}
              classes={classes.root}
              label="Buscando dados..."
            />
          </Grid>
          {dataTable && !cancelLoading && !searching && (
            <Grid item xs={12}>
              <TabelaMonitorInfracommerce dataTable={dataTable} />
            </Grid>
          )}
        </Grid>
      </Container>
    </>
  );
}
